<template>
  <div ref="pillGroup" class="flex flex-row gap-1">
    <div v-for="item in items" v-show="!hiddenPills.includes(`${item.id}`)" :key="item.id" :data-item-id="item.id">
      <HoverTooltip :disabled="item.name.length <= 25">
        <template #subject>
          <Pill
            :item="item"
            :text="item.name"
            :color="color"
            :color-shade="colorShade"
            :text-color="textColor"
            :text-length="25"
            :dismissable="dismissable"
            @click="dismissable && handleDismiss(item)"
          />
        </template>
        <template #tooltip>
          {{ item.name }}
        </template>
      </HoverTooltip>
    </div>
    <HoverTooltip ref="countPill">
      <template #subject>
        <Pill v-if="count > 0" :text="`+${count}`" :color-shade="colorShade" :text-color="textColor" :color="color" />
      </template>
      <template #tooltip>
        {{ tooltipText }}
      </template>
    </HoverTooltip>
  </div>
</template>
<script>
import { debounce } from 'lodash';
import { Pill, HoverTooltip } from "@sportsrecruits/playbook";

export default {
  components: {
    Pill,
    HoverTooltip,
  },
  props: {
    color: { type: String, default: 'gray' },
    colorShade: { type: String, default: 'light' },
    textColor: { type: String, default: 'text-gray-700' },
    items: { type: Array, required: true },
    dismissable: { type: Boolean, default: false },
  },
  data() {
    return {
      count: 0,
      hiddenPills: [],
      observer: null,
    }
  },
  computed: {
    tooltipText() {
      return this
        .hiddenPills
        .map(pill => this.items.find(item => item.id == pill)?.name)
        .filter(item => item)
        .join(' • ');
    },
  },
  watch: {
    items: {
      handler() {
        this.resizeObserver()
      },
    },
  },
  mounted() {
    this.observer = new ResizeObserver(debounce(this.resizeObserver, 10));
    this.observer.observe(this.$refs.pillGroup);
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
  methods: {
    resizeObserver() {
      // there should be only one entry
      const container = this.$refs.pillGroup;
      const countPill = this.$refs.countPill.$el;
      const firstChild = container.children[0];
      if (!firstChild) {
        return;
      }

      const containerRight = container.getBoundingClientRect().right;
      // guestimate: we don't know the width of the count pill when it's hidden
      const countPillWidth = countPill.getBoundingClientRect().width || 30;

      this.count = 0;
      this.hiddenPills = [];

      this.$nextTick(() => {
        for (const child of this.$refs.pillGroup.children) {
          const childKey = child.dataset.itemId;
          if (child === firstChild) {
            continue;
          }

          if (child === countPill) {
            continue;
          }

          const childRight = child.getBoundingClientRect().right;
          const shouldHide = childRight >= (containerRight - countPillWidth);
          if (shouldHide) {
            this.count++;
            this.hiddenPills.push(childKey);
          }
        }
      });
    },
    handleDismiss(item) {
      this.$emit('dismiss', item)
    },
  },
}
</script>
